import {stepName as connectPayoutAccount} from './steps/connectPayoutAccount'
import {stepName as connectExpenseAccount} from './steps/connectExpenseAccount'
import {stepName as idVerification} from './steps/idVerification'
import {stepName as signAgreement} from './steps/signAgreement'
import {stepName as updateInvoiceTemplate} from './steps/updateInvoiceTemplate'
import {stepName as invitePayersToMarmalade} from './steps/invitePayersToMarmalade'
import {stepName as invoiceEmailTemplate} from './steps/invoiceEmailTemplate'

export default ({
  bankingProviderApprovalStatus,
  approvedBankConnectionRequired,
  verificationStatus,
  manualKycDone,
  supplierAgreementAccepted,
  marmaladeInvoiceSetupStatus,
  canVerifyIdentity,
  invoiceEmailTemplateProgress,
  payerTransitionCompleted,
  connectedExpenseAccount,
  features,
}) => {
  if (
    approvedBankConnectionRequired &&
    bankingProviderApprovalStatus === 'incomplete'
  ) {
    return connectPayoutAccount
  }

  if (!connectedExpenseAccount) {
    return connectExpenseAccount
  }

  if (!supplierAgreementAccepted) {
    return signAgreement
  }

  if (
    verificationStatus !== 'verified' &&
    !manualKycDone &&
    canVerifyIdentity
  ) {
    return idVerification
  }

  // The standalone invoice template step is replaced by the combined invoice and
  // email template step once invitePayersToMarmalade is enabled.
  if (
    !features.invitePayersToMarmalade &&
    marmaladeInvoiceSetupStatus !== 'verified'
  ) {
    return updateInvoiceTemplate
  }

  if (
    features.invitePayersToMarmalade &&
    invoiceEmailTemplateProgress?.status !== 'verified'
  ) {
    return invoiceEmailTemplate
  }

  if (features.invitePayersToMarmalade && !payerTransitionCompleted) {
    return invitePayersToMarmalade
  }

  return null
}
